import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { BlockRenderer } from '../components/blocks/BlockComponents';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SponsorshipPage = () => {
  const [pageBlocks, setPageBlocks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadBlocks = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/pages/sponsorship`);
        if (response.ok) {
          const data = await response.json();
          setPageBlocks(data.blocks || []);
        }
      } catch (err) {
        console.error('Failed to load partnerships page blocks:', err);
      } finally {
        setIsLoading(false);
      }
    };
    loadBlocks();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  const sortedBlocks = [...pageBlocks].sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div className="min-h-screen pt-24 pb-12" data-testid="partnerships-page">
      {sortedBlocks.map((block) => (
        <BlockRenderer key={block.id} block={block} />
      ))}
    </div>
  );
};

export default SponsorshipPage;
